import qs from "qs";

/* Static Area */
export function isEmpty(obj: any){ return obj === undefined || obj == null; }
export function isEmptyString(str: any){ return isEmpty(str) || trim(str) === ""; }
export function isNullOrWhiteSpace(str: any) { return str == null || isEmptyString(str.toString().trim()); }
/**
 *
 * @param {string} str
 * @returns {string}
 */
export function trim(str: string)
{
    try { return str.trim().replace(/^\s+|\s+$/g,""); }
    catch (e) { return str;}
}


export const getURLParams = (): qs.ParsedQs => qs.parse(location.search, { ignoreQueryPrefix: true });
export function getKeyFromURL()
{
    const params = getURLParams();
    const token_id = params.token_id + '';
    //흙사랑 공인중개사
    return isNullOrWhiteSpace(token_id) ? 'cUMTT8m7LWAGJAZPEMKqLtMgEeiuBgo4nVPT8Eyz' : token_id;
}